import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  InputLabel,
  TextField,
  MenuItem,
  Paper,
  Typography,
  Link,
  CircularProgress,
  Divider,
} from "@mui/material";

import { Card, CardHeader, Badge, CardContent, Stack } from "@mui/material";
import Chart from "react-apexcharts";
import { getSalesOrderList, getSalesGraph } from "../../api/dashboard";
import { useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";

export default function Dashboard() {
  const { data: user } = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState("SalesOrd");
  const [salesOrder, setSalesOrder] = useState("");
  const [series, setSeries] = useState([]);
  const [date, setDate] = useState("360");

  const options = {
    labels: [
      "Pending Approval",
      "Pending Ful-Fillment",
      "Cancelled",
      "Partially Ful-Filled",
      "Pending Billing Partially Ful-filled",
      "Pending Billing",
      "Billed",
      "Closed",
    ],
  };

  const snackbar = useSnackbar();

  useEffect(() => {
    if (user?.token) {
      getSalesOrderData();
      getSalesOrder();
    }
  }, [user.token, filter, date]);

  const [rowData, setRowData] = useState([{}]);

  async function getSalesOrderData() {
    setLoading(true);
    try {
      // const { data } = await getSalesOrderList(user.token, {
      //   type: filter,
      //   days: date,
      // });
      // const responseData = data.data.data;

      // setRowData(responseData);
      // setLoading(false);
    } catch (error) {
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
    } finally {
      // setLoading(false)
    }
  }

  async function getSalesOrder() {
    try {
      // const { data } = await getSalesGraph(user.token, {
      //   type: filter,
      //   days: date,
      // });
      // const responseData = data.data.data;
      // setSeries([
      //   parseInt(responseData[0].pendingapproval),
      //   parseInt(responseData[0].pendingfulfillment),
      //   parseInt(responseData[0].cancelled),
      //   parseInt(responseData[0].partiallyfulfilled),
      //   parseInt(responseData[0].pendingbillingpartiallyfulfilled),
      //   parseInt(responseData[0].pendingbilling),
      //   parseInt(responseData[0].billed),
      //   parseInt(responseData[0].closed),
      // ]);
    } catch (error) {
      setSeries([0, 0, 0, 0, 0, 0, 0, 0]);
      snackbar.showError("Error In Loading Data.");
    } finally {
      // setLoading(false)
    }
  }

  const AreaOptions = {
    plotOptions: {
      bar: {
        horizontal: true, //horizontal bar chart
      },
    },

    options: {
      chart: {
        id: "basic-bar",
      },
      xaxis: {
        categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999],
      },
    },
  };
  const AreaSeries = [
    {
      name: "Guests",
      data: [30, 40, 45, 50, 49, 60, 70, 91],
    },
  ];

  return loading ? (
    <div
      style={{
        // do your styles depending on your needs.
        width: "100%",

        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularProgress></CircularProgress>
    </div>
  ) : (
    <>
      <Box>
        <Grid container>
          <Grid item md={6} xs={12}>
            <Grid container>
              <Grid className="gridText" item md={2} xs={4}>
                <InputLabel className="inputText">Days</InputLabel>
              </Grid>
              <Grid item md={9} xs={7}>
                <TextField
                  id="outlined-select-currency"
                  select
                  label={`Last ${
                    date === "360" ? "1 Year" : date + " " + "days"
                  } `}
                  fullWidth
                  onChange={(e) => {
                    setDate(e.target.value);
                  }}
                  size="small"
                >
                  {/* <MenuItem value="30">Last 30 days</MenuItem> */}
                  <MenuItem value="60">Last 60 days</MenuItem>
                  <MenuItem value="90">Last 90 days</MenuItem>
                  <MenuItem value="120">Last 120 days</MenuItem>
                  <MenuItem value="150">Last 150 days</MenuItem>
                  <MenuItem value="180">Last 180 days</MenuItem>
                  <MenuItem value="210">Last 210 days</MenuItem>
                  <MenuItem value="240">Last 240 days</MenuItem>
                  <MenuItem value="360">Last 1 Year</MenuItem>
                </TextField>
              </Grid>
            </Grid>
          </Grid>

          <Grid item md={6} xs={12} className="displayFlex">
            <Grid container>
              <Grid className="gridText" item md={4} xs={12}>
                <InputLabel className="inputText">
                  Select Transaction
                </InputLabel>
              </Grid>
              <Grid item md={8} xs={12}>
                <TextField
                  id="outlined-select-currency-native"
                  select
                  label={
                    filter === "SalesOrd"
                      ? "Sales Order"
                      : filter === "PurchOrd"
                      ? "Purchase Order"
                      : "Bill Payment"
                  }
                  fullWidth
                  value={salesOrder}
                  onChange={(e) => {
                    setSalesOrder(e.target.value);
                    setFilter(e.target.value);
                  }}
                  size="small"
                >
                  <MenuItem value="SalesOrd">Sales Order</MenuItem>
                  <MenuItem value="PurchOrd">Purchase Order</MenuItem>
                  {/* <MenuItem value="VendPymt">Bill Payment</MenuItem> */}
                </TextField>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/*sales order*/}
        <Box container>
          <Paper
            className="paper-box-shadow"
            sx={{ width: "100%", my: "0px", mt: 2 }}
          >
            <Typography
              variant="h6"
              className="pageHeading1"
              sx={{ p: "10px" }}
            >
              {filter === "SalesOrd"
                ? "Sales Order"
                : filter === "PurchOrd"
                ? "Purchase Order"
                : "Bill Payment"}
            </Typography>
            <Divider />
            <Grid container>
              {rowData.map((item, i) => {
                return (
                  <Grid
                    item
                    md={2}
                    sm={4}
                    xs={6}
                    key={i}
                    className="dashboard-card"
                  >
                    <Box className="dashboard-card-bkg">
                      <Link to="/" style={{ textDecoration: "none" }}>
                        <Card
                          className="media-card"
                          sx={{ backgroundColor: "#437c94" }}
                        >
                          <CardHeader
                            title={
                              <Badge
                                className="t-BadgeList-value "
                                badgeContent={item.total_status}
                                max={99999999}
                                color="secondary"
                              ></Badge>
                            }
                          />
                          <CardContent>
                            <Typography className="title" color="textSecondary">
                              {item.status ? item.status : "No title"}
                            </Typography>
                          </CardContent>
                        </Card>
                      </Link>
                    </Box>
                  </Grid>
                );
              })}
            </Grid>
          </Paper>

          {/*Chart*/}
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <Paper
                className="paper-box-shadow chartboxHeight"
                sx={{ p: "1rem", mt: 2 }}
              >
                <Typography variant="h6" className="mui-heading" align="center">
                  {filter === "SalesOrd"
                    ? "Sales Order"
                    : filter === "PurchOrd"
                    ? "Purchase Order"
                    : "Bill Payment"}{" "}
                  Status
                </Typography>

                {series ? (
                  series[0] === 0 &&
                  series[1] === 0 &&
                  series[2] === 0 &&
                  series[3] === 0 &&
                  series[4] === 0 &&
                  series[5] === 0 &&
                  series[6] === 0 &&
                  series[7] === 0 ? (
                    <Paper>
                      <Box height="230px" width={700} pt="15px" pr="10px">
                        <Stack
                          direction="row"
                          justifyContent="center"
                          alignItems="center"
                        >
                          <div class="circle"></div>

                          <div class="smallcircle"></div>

                          <p style={{ marginLeft: "5px" }}>No Data</p>
                        </Stack>
                      </Box>
                    </Paper>
                  ) : (
                    <Chart
                      options={options}
                      series={series}
                      type="pie"
                      //width="450"
                      width={"100%"}
                      height={400}
                    />
                  )
                ) : null}
              </Paper>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
}
